var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F2F3F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2559 9.92259C19.5814 9.59715 19.5814 9.06951 19.2559 8.74408C18.9305 8.41864 18.4028 8.41864 18.0774 8.74408L14 12.8215L9.92259 8.74408C9.59715 8.41864 9.06951 8.41864 8.74408 8.74408C8.41864 9.06951 8.41864 9.59715 8.74408 9.92259L12.8215 14L8.74408 18.0774C8.41864 18.4028 8.41864 18.9305 8.74408 19.2559C9.06951 19.5814 9.59715 19.5814 9.92259 19.2559L14 15.1785L18.0774 19.2559C18.4028 19.5814 18.9305 19.5814 19.2559 19.2559C19.5814 18.9305 19.5814 18.4028 19.2559 18.0774L15.1785 14L19.2559 9.92259Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.679fbf9079d3f96ff70dfa7aa47a98de.svg";
export { ForwardRef as ReactComponent };